<template>
    <b-row>
        <b-col cols="12">
            <h2 class="m-0 h1 text-uppercase">
                {{ $t('parcelas.selecciona_parcelas') }}
            </h2>
        </b-col>
        <b-col cols="12">
            <transition name="fade" mode="out-in">
                <b-row key="parcelas" id="parcelas">
                    <b-col cols="12" md="8">
                        <div class="d-flex justify-content-between align-items-center mb-2 mt-2 mt-md-0">
                            <h3 class="subtitle h3 light mb-3">{{ $t('parcelas.selecciona_parcelas') }}:</h3>
                            <Button
                                @click="$emit('cambiarZona')"
                                :disabled="loading || disabled"
                            >
                                Cambiar zona
                            </Button>
                        </div>
                        <ContentOrLoading>
                            <div class="lightgray-content" v-if="!loading && svgRendered">
                                <LeafletComponent
                                    :svgRendered="svgRendered"
                                    :originalColor="originalColor"
                                    :plazasSeleccionadas="parcelasSeleccionadas"
                                />
                            </div>
                        </ContentOrLoading>
                    </b-col>
                    <b-col class="mt-3 mt-md-5 pt-md-2" cols="12" md="4" v-if="parcelasSeleccionadas.length">
                        <b-row>
                            <b-col cols="12">
                                <div class="d-flex flex-column justify-content-between">
                                    <div class="overflow-auto">
                                        <div
                                            v-for="(parcela, index) in parcelasSeleccionadas"
                                            class="bg-white rounded p-2 mb-2"
                                            :key="index"
                                        >
                                            <div class="text-bold mb-2 d-flex justify-content-between align-items-center">
                                                <div class="oswald d-flex">
                                                    {{ num = index + 1 }}.&nbsp; <span v-html="getParcelaName(parcela)"></span>
                                                </div>
                                                <span
                                                    role="button"
                                                    aria-label="Eliminar parcela"
                                                    @click="disabled ? null : eliminarParcela(parcela)"
                                                    class="text-danger ml-2"
                                                    style="cursor: pointer; font-weight: bold; font-size: 20px;"
                                                >
                                                    &times;
                                                </span>
                                            </div>
                                            <div class="form-group mb-1">
                                                <ValidationProvider
                                                    :name="'precio' + index"
                                                    rules="required"
                                                    v-slot="{ errors }"
                                                >
                                                    <select
                                                        :class="'form-control' + (errors[0] ? 'is-invalid' : '')"
                                                        v-model="parcela.precioSeleccionado"
                                                        name="precio"
                                                        data-cy="selectParcelas"
                                                        :disabled="disabled"
                                                    >
                                                        <option :value="undefined" disabled hidden>
                                                            {{ $t("parcelas.tipo_precio") }}
                                                        </option>
                                                        <option
                                                            v-for="(precio, index) in parcela.precios"
                                                            :key="index"
                                                            :value="precio"
                                                        >
                                                            {{ precio.descripcion }} | {{ precio.precio | formatear_precio }}
                                                        </option>
                                                    </select>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col cols="12" v-if="parcelasConPrecios">
                                <Button
                                    :label="$t('partido.continuar')"
                                    :disabled="loading || disabled"
                                    custom-class="btn-block"
                                    @click="continuarCompra"
                                />
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </transition>
        </b-col>
    </b-row>
</template>

<script>
    import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
    import { Popover } from 'bootstrap';
    import Button from '@/modules/ui/Button.vue';

    export default {
        props: {
            zona: {
                type: Object,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                parcelas: [],
                loading: false,
                svgRendered: null,
                originalColor: '#0CBA31',
                parcelasSeleccionadas: [],
                seleccionadaColor: '#457ad1'
            }
        },
        methods: {
            getSvg() {
                const params = {
                    filters: {},
                    zona_id: this.zona.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.zonas.svg'), params).then(res => {
                    this.renderSvg(res.data.svg);
                }).catch(() => {
                    this.$toast.error('Error al recuperar el svg en la configuración de precios de abonos');
                }).finally(() => {
                    this.loading = false;
                });
            },
            getParcelas() {
                this.loading = true;

                const params = {
                    filters: {},
                    lista_abonado_id: this.lista.id,
                    place_id: this.lista.recinto_parcela_id,
                    zona_id: this.zona.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.parcelas.zona.butacas'), params).then(res => {
                    this.parcelas = res.data.data?.filter(parcela => parcela.svg_id);
                    this.getSvg();
                }).finally(() => {
                    this.loading = false;
                });
            },
            renderSvg(svg) {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = svg;

                const svgElement = tempDiv.firstElementChild;
                const parcelas = svgElement.querySelectorAll('[id^="butaca"]');
                const isMobile = window.innerWidth <= 768;

                parcelas.forEach(element => {
                    element.setAttribute('seleccionado', 'false');
                    const svg_id = this.getParcelaId(element);
                    const parcela = this.parcelas.find(parcela => parcela.svg_id == svg_id);

                    if (parcela) {
                        const title = this.getParcelaName(parcela);

                        if (!isMobile) {
                            this.drawPopover(element, parcela, title);
                        }

                        if(parcela.precios.length === 0) {
                            element.setAttribute('fill', 'gray');
                            parcela.originalColor = 'gray';
                        } else {
                            element.setAttribute('fill', this.originalColor);
                            parcela.originalColor = this.originalColor;
                        }

                        if (!this.disabled) {
                            element.addEventListener('click', () => {
                                let isSeleccionado = JSON.parse(element.getAttribute('seleccionado'));

                                setTimeout(() => {
                                    if (!this.isPanning) {
                                        if (!isSeleccionado) {
                                            element.setAttribute('fill', this.seleccionadaColor);
                                            element.setAttribute('seleccionado', 'true');
                                        } else {
                                            element.setAttribute('fill', parcela.originalColor);
                                            element.setAttribute('seleccionado', 'false');
                                        }
                                        this.clickParcela(parcela.id);
                                    }
                                }, 150);
                            });
                        } else {
                            element.style.cursor = 'not-allowed';
                            element.style.pointerEvents = 'none';
                            element.setAttribute('fill', '#ccc');
                        }
                    }
                });

                this.svgRendered = tempDiv.firstElementChild;
                setTimeout(() => {
                    this.$scrollTo('#plano', 50);
                }, 70);
            },
            getParcelaId(element) {
                const id = element.id;
                const idParts = id.split("-");

                return idParts[1];
            },
            getParcelaName(parcela) {
                return `${this.teatro.hash === 'J1fKG9AarPuPNJ5hwY0t' ? 'Terreno' : 'Parcela'} Nº ${parcela.numero}`;
            },
            drawPopover(element, parcela, title = null) {
                let content = '';

                const precios = this.generatePriceContent(parcela.precios);
                if (precios !== '') {
                    content += '<b>Precios:</b>';
                    content += precios;
                }

                const popoverOptions = {
                    title: title,
                    content: content,
                    trigger: 'hover',
                    html: true
                }

                new Popover(element, popoverOptions);
            },
            generatePriceContent(precios) {
                let content = '';

                content += '<ul class="pb-0 mb-0">';

                precios.forEach(precio => {
                    content += `<li>${precio.descripcion} | ${this.$n(precio.precio, 'currency')}</li>`;
                });

                content += '</ul>';

                return content;
            },
            clickParcela(parcela_id) {
                let parcelaSeleccionada = this.parcelas.find(parcela => parcela.id == parcela_id);

                if (parcelaSeleccionada) {
                    parcelaSeleccionada.seleccionada = parcelaSeleccionada?.seleccionada && parcelaSeleccionada.seleccionada ? false : true;
                    if (parcelaSeleccionada.seleccionada) {
                        if (parcelaSeleccionada.precios.length === 1) {
                            parcelaSeleccionada.precioSeleccionado = parcelaSeleccionada.precios[0];
                        }
                        this.parcelasSeleccionadas.push(parcelaSeleccionada)
                    } else {
                        const index = this.parcelasSeleccionadas.findIndex(parcela => parcela.id == parcelaSeleccionada.id);

                        if (index !== -1) {
                            this.parcelasSeleccionadas.splice(index, 1);
                        }
                    }
                }
            },
            eliminarParcela(parcela) {
                const index = this.parcelasSeleccionadas.findIndex(p => p.id === parcela.id);
                if (index !== -1) {
                    this.parcelasSeleccionadas.splice(index, 1);
                }

                const svgElement = this.svgRendered?.querySelector(`#butaca-${parcela.svg_id}`);
                if (svgElement) {
                    svgElement.setAttribute('fill', parcela.originalColor || this.originalColor);
                    svgElement.setAttribute('seleccionado', 'false');
                }

                const parcelaOriginal = this.parcelas.find(p => p.id === parcela.id);
                if (parcelaOriginal) {
                    parcelaOriginal.seleccionada = false;
                }
            },
            continuarCompra() {
                this.$emit('terminado', this.parcelasSeleccionadas);
            }
        },
        computed: {
            lista() {
                return this.$store.getters.getListaAbonados;
            },
            parcelasConPrecios() {
                return this.parcelasSeleccionadas.every(parcela => parcela.precioSeleccionado);
            },
            teatro(){
                return this.$store.getters.getTeatro
            }
        },
        created() {
            this.getParcelas();
        },
        components: {
            LeafletComponent, Button
        },
        watch: {
            disabled(newValue) {
                if (this.svgRendered) {
                    const parcelas = this.svgRendered.querySelectorAll('[id^="butaca"]');

                    parcelas.forEach(element => {
                        const svg_id = this.getParcelaId(element);
                        const parcela = this.parcelas.find(parcela => parcela.svg_id == svg_id);

                        if (parcela) {
                            if (newValue) {
                                element.style.cursor = 'not-allowed';
                                element.style.pointerEvents = 'none';
                                element.setAttribute('fill', '#ccc');
                            } else {
                                element.style.cursor = 'pointer';
                                element.style.pointerEvents = 'auto';
                                element.setAttribute('fill', parcela.originalColor || this.originalColor);
                            }
                        }
                    });
                }
            }
        }
    }
</script>
